import { BoundSelectField, FormLines, ModalBody, ModalFooter, ModalHeader, useModal } from "@homebound/beam";
import { FormActions } from "src/components";
import { CostType, Scalars } from "src/generated/graphqlTypes";
import { useAddItemModalQuery } from "src/routes/projects/selections/AddProjectItemModal.generated";
import { safeEntries } from "src/utils";
import { ObjectConfig, required, useFormState } from "src/utils/formState";

type AddItemModalProps = {
  /** Passes the form input back to the page b/c we have per-page GQL mutation calls. */
  onAdd: (input: AddSingleItemInput) => Promise<void>;
};

/** Adds a single new project item to pre-sign Specs & Selections. */
export function AddProjectItemModal(props: AddItemModalProps) {
  const { onAdd } = props;
  const { closeModal } = useModal();
  const query = useAddItemModalQuery({ fetchPolicy: "cache-first" });

  const items = query.data?.items || [];

  const formState = useFormState({ config: formConfig });

  return (
    <>
      <ModalHeader>Add Item</ModalHeader>
      <ModalBody>
        <FormLines>
          <BoundSelectField
            field={formState.itemId}
            options={items}
            getOptionLabel={(item) => item.displayName}
            getOptionValue={(item) => item.id}
          />
          <BoundSelectField
            field={formState.costType}
            options={safeEntries(CostType)}
            getOptionLabel={([name]) => name}
            getOptionValue={([, code]) => code}
          />
        </FormLines>
      </ModalBody>
      <ModalFooter>
        <FormActions
          mode="create"
          formState={formState}
          onSave={async () => {
            await onAdd(formState.value);
            closeModal();
          }}
          primaryLabel="Add"
          onCancel={closeModal}
          onEdit={() => {}}
        />
      </ModalFooter>
    </>
  );
}

export type AddSingleItemInput = {
  itemId?: string | null;
  costType?: CostType | null;
  locationId?: string | null;
  unitOfMeasureId?: string | null;
  quantity?: Scalars["Int"]["input"] | null;
};

const formConfig: ObjectConfig<AddSingleItemInput> = {
  itemId: { type: "value", rules: [required] },
  costType: { type: "value", rules: [required] },
};
